import Vue from 'vue'
import VueKonva from 'vue-konva'

function init () {
    Vue.use(VueKonva)
}

export default {
    init
}



// WEBPACK FOOTER //
// ./src/components/ploter/index.js